import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Data Service Health API - Direct health checks for the main backend service
 */
export const DataHealthApi = {
  /**
   * Public health check for Data-Service (hibernate-service)
   * This endpoint doesn't require authentication
   * Used on login page to wake up the service if it's sleeping in Cloud Run
   * @returns {Promise<Response>} Health check response
   */
  checkHealth: async () => {
    try {
      console.log('DataHealthApi: Checking Data-Service health...');

      const response = await fetch(`${DATA_SERVICE_BASE_URL}/health`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('DataHealthApi: Health check response:', response.status);
      return response;
    } catch (error) {
      console.error('DataHealthApi: Health check failed:', error);
      throw error;
    }
  },

  /**
   * Check if Data-Service is available
   * @returns {Promise<boolean>} Service availability
   */
  isServiceAvailable: async () => {
    try {
      const response = await DataHealthApi.checkHealth();
      return response.ok;
    } catch (error) {
      console.error('Data-Service health check failed:', error);
      return false;
    }
  },

  /**
   * Get service info from health check (if available)
   * @returns {Promise<Object|null>} Service info or null if unavailable
   */
  getServiceInfo: async () => {
    try {
      const response = await DataHealthApi.checkHealth();
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          return await response.json();
        }
        // If not JSON, just return a simple status object
        return { status: 'ok' };
      }
      return null;
    } catch (error) {
      console.error('Failed to get Data-Service info:', error);
      return null;
    }
  },
};
